// Zone.js runtime flags
// Set before importing zone.js (see polyfills.ts)

// Reduce patching overhead for better performance, especially in Safari.
(window as any).__Zone_disable_requestAnimationFrame = true; // do not patch rAF
(window as any).__Zone_disable_on_property = true; // disable onproperty* patching
// Unpatch noisy events; Angular still listens via addEventListener.
(window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove', 'touchmove', 'wheel'];

// Optional: disable patching for rarely used APIs
(window as any).__Zone_disable_geolocation = true;
(window as any).__Zone_disable_file = true;
(window as any).__Zone_disable_FileReader = true;
